<template>
  <div>
    <div v-show="showToast" class="overlay-mask" @touchmove.prevent></div>
    <router-view></router-view>
    <div id="app-watermark"></div>
  </div>
</template>
<script>
import watermark from 'watermark-dom'
import { Toast } from 'vant'
export default {
  name: "reportInfo",
  data() {
    return {
      showToast: true  // 控制遮罩层显示
    };
  },
  methods: {
    anonymize(str) {
      // 处理空字符串或只有一个字符的情况
      if (!str || str.length <= 1) {
        return str;
      }
      // 保留第一个字符，其余用*替换
      return str[0] + '**'
    }
  },
  mounted(){
    const watermarkTxt = this.$route.query.name
    const isWaterMark = this.$route.query.isWaterMark
    const short = this.$route.query.short
    const isAnonymous = this.$route.query.isAnonymous
    const pushLinkType = this.$route.query.pushLinkType
    if(short == 1 && pushLinkType !=1 ) {
      Toast({
        message: `请注意保护隐私安全\n\n此页面禁止截图，如因截图及拍照所产生纠纷由个人承担法律责任。`,
        duration: 3000,
        position: 'middle',
        // icon: 'smile-comment-o',
        className: 'custom-toast',
        forbidClick: true,
        onOpened: () => {
          // 提示框显示时禁止页面滚动
          document.body.style.overflow = 'hidden';
        },
        onClose: () => {
          // 提示框关闭后恢复页面滚动
          document.body.style.overflow = '';
          this.showToast = false;
        }
      });
    } 
     
    if(isWaterMark == 1) {
      watermark.init({
        watermark_txt: isAnonymous == 1 ? this.anonymize(this.$route.query.name) : watermarkTxt,  // 水印文本
        watermark_color: "#666",        // 字体颜色
        watermark_fontsize: "18px",     // 字体大小
        watermark_alpha: 0.1,           // 透明度
        watermark_angle: 15,             // 倾斜角度
        watermark_x: 50,                // 横向间距
        watermark_y: 100,                // 纵向间距
      });
    }
   
  },
  beforeDestroy() {
    // 确保离开页面时恢复滚动
    document.body.classList.remove('overflow-hidden');
  }
};
</script>
<style scoped>
@import "../../style/reportInfo/index.css";
.custom-toast {
  width: 60%;
  min-height: 40px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
}
</style>

